import { render, staticRenderFns } from "./PlageHoraire.vue?vue&type=template&id=1a28ca1c&"
import script from "./PlageHoraire.vue?vue&type=script&lang=js&"
export * from "./PlageHoraire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports